<h2 class="align-data"><strong>Application version: </strong><span class="version">{{getVersion()}}</span></h2>
<h2 class="align-data"><strong>Revision: </strong><span class="version">{{getHash()}}</span></h2>
<h2 class="align-data"><strong>Source built: </strong><span class="version">{{getDatetime()}}</span></h2>
